import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableHeadText, TableColText } from '../../../../../components/pdf/TableHelpers'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import Separator from '../../../../../components/pdf/Separator'
import {
  sumAllTotalAmount,
  sumEquipmentTotalAmount,
  sumServiceTotalAmount,
  toCurrency
} from '../../_helpers/pdfHelpers'

const Invoice = ({ data }) => {
  return (
    <View>
      {!!data.services.length && (
        <>
          <Separator weight={4} />
          <Text bold size="h4" align="left">
            Fatura - Serviços
          </Text>
          <Separator weight={2} />
          <Table justify="space-between" width={'100%'} useFontBaseColor>
            <TableRow useFontBaseColor>
              <TableHeadText width={'60%'} align="center" useFontBaseColor>
                Descrição
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Qtd
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Preço Unitário
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Preço Total
              </TableHeadText>
            </TableRow>
            {data.services.map(item => {
              return (
                <>
                  <TableRow useFontBaseColor>
                    <TableColText width={'60%'} align="center" useFontBaseColor>
                      {item.service}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {item.amount}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {toCurrency(item.unitPrice)}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {toCurrency(item.totalAmount)}
                    </TableColText>
                  </TableRow>
                </>
              )
            })}
            <TableRow useFontBaseColor>
              <TableHeadText align="center" useFontBaseColor colSpan={3}>
                Valor Total
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                {toCurrency(sumServiceTotalAmount(data))}
              </TableHeadText>
            </TableRow>
          </Table>
        </>
      )}

      {!!data.equipments.length && (
        <>
          <Separator weight={4} />
          <Text bold size="h4" align="left">
            Fatura - Equipamentos
          </Text>
          <Separator weight={2} />
          <Table justify="space-between" width={'100%'} useFontBaseColor>
            <TableRow useFontBaseColor>
              <TableHeadText width={'60%'} align="center" useFontBaseColor>
                Descrição
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Qtd
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Preço Unitário
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                Preço Total
              </TableHeadText>
            </TableRow>
            {data.equipments.map(item => {
              return (
                <>
                  <TableRow useFontBaseColor>
                    <TableColText width={'60%'} align="center" useFontBaseColor>
                      {item.service}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {item.amount}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {toCurrency(item.unitPrice)}
                    </TableColText>
                    <TableColText align="center" useFontBaseColor>
                      {toCurrency(item.totalAmount)}
                    </TableColText>
                  </TableRow>
                </>
              )
            })}
            <TableRow useFontBaseColor>
              <TableHeadText align="center" useFontBaseColor colSpan={3}>
                Valor Total
              </TableHeadText>
              <TableHeadText align="center" useFontBaseColor>
                {toCurrency(sumEquipmentTotalAmount(data))}
              </TableHeadText>
            </TableRow>
          </Table>
        </>
      )}
      <Separator weight={4} />

      <Text bold size="h4" align="right">
        Total: {toCurrency(sumAllTotalAmount(data))}
      </Text>

      <Separator weight={4} />
    </View>
  )
}

export default Invoice
